import $ from 'jquery';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/login-password-reset.hbs';
import InvalidTokenTemplate from '@/../templates/login-password-reset-invalid-token.hbs';

    var globalCh = Radio.channel('global');
    /**
     * After the user successfully requests a new password,
     * show a message and redirect to the login page
     */
    function alert_request_success_and_redirect_to_login() {
        // Display success message for five seconds
        Radio.request(
            'alerts',
            'showAlert', {
                message: 'Your password was successfully changed. '
                       + 'Please log in with your new password.',
                messageType: 'success'
            }
        );
        globalCh.request('login');
    }
    /**
     * Alert an error from the API
     */
    function alert_request_error(resp) {
        var message;
        if (!(resp && resp.responseJSON && resp.responseJSON.errors))
            message = 'An unknown error occurred.';
        else {
            message = resp.responseJSON.errors.map(function(e) {
                return e.detail;
            }).join('; ');
        }
        Radio.request(
            'alerts',
            'showAlert', {
                message: message,
                messageType: 'danger'
            }
        );
    }
    
    export default Marionette.View.extend({
        template: Handlebars.compile(template),
        className: 'reset_password',
        events: {
            'submit #password-reset-form': 'resetButtonPress',
            'click #password-reset-button': 'loadForgotPassword'
        },
        initialize: function(options) {
            if (options.invalidToken) {
                this.template = Handlebars.compile(InvalidTokenTemplate);
            }
        },
        loadForgotPassword: function() {
            globalCh.request('forgot_password');
        },
        resetButtonPress: function(event) {
            event.preventDefault();
            var msg;
            var pw1 = $('#password').val();
            var pw2 = $('#passwordConfirm').val();
            this.model.set('password', pw1);
            // Make sure passwords are not empty
            if (pw1 === "" || pw2 === "") {
                msg = "Your password fields cannot be empty.";
                Radio.request(
                    'alerts',
                    'showAlert', {
                        message: msg,
                        messageType: 'danger'
                    }
                );
                return;
            }

            // If the two passwords don't match
            if (pw1 !== pw2) {
                msg = "Your passwords must match. Please try again.";
                Radio.request(
                    'alerts',
                    'showAlert', {
                        message: msg,
                        messageType: 'danger'
                    }
                );
                return;
            }

            // Make sure the required length of 8 is met
            if (pw1.length < 8) {
                msg = "Your password must be at least 8 characters.";
                Radio.request(
                    'alerts',
                    'showAlert', {
                        message: msg,
                        messageType: 'danger'
                    }
                );
                return;
            }

            this.model.set('password', pw1);
            this.model.reset_password()
                .done(alert_request_success_and_redirect_to_login)
                .fail(alert_request_error);
        }

    });

